import { Layout, Notification } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmailInput, FileUpload, PhonenumberInput, TextArea, TextInput } from '../../simple-form-components';
import { useContactInformationChangeStatus } from '../../../../../../my-profile/useContactInformationChangeStatus';
import { RequestStatus } from 'cpfr-common';

export const OtherForm: React.FC = () => {
    const { t } = useTranslation('request');
    const { data: contactInformationChange } = useContactInformationChangeStatus();
    const isContactChangePending = contactInformationChange?.requestCustomerStatus === RequestStatus.IN_PROGRESS;
    const translationPrefix = 'category-selection.other';

    const translate = (key: string): string => {
        return t(`${translationPrefix}.${key}`);
    };

    return (
        <>
            {isContactChangePending && !!contactInformationChange?.requestCustomerStatus ? (
                <Layout.Item>
                    <Notification
                        title={''}
                        hideTitle={true}
                        className="u-mb"
                        visible
                        testId="pending-change-notification"
                        showCloseButton={false}
                        status={'warning'}
                    >
                        <p
                            dangerouslySetInnerHTML={{
                                __html: translate('pending-contact-information-change'),
                            }}
                        />
                    </Notification>
                </Layout.Item>
            ) : (
                <>
                    <Layout.Item>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: translate('description'),
                            }}
                        />
                    </Layout.Item>
                    <Layout.Item>
                        <EmailInput label={translate('email')} name={'other.email'} inputId="email-other-form" />
                    </Layout.Item>
                    <Layout.Item>
                        <PhonenumberInput
                            label={translate('phonenumber')}
                            name={'other.phonenumber'}
                            isMandatory
                            inputId="phone-number-other-form"
                        />
                    </Layout.Item>
                    <Layout.Item>
                        <TextInput label={translate('subject-of-claim')} name={'other.subjectOfClaim'} />
                    </Layout.Item>
                    <Layout.Item>
                        <TextArea label={translate('message')} name={'other.message'} />
                    </Layout.Item>
                    <Layout.Item>
                        <FileUpload
                            name={'other.files.attachment'}
                            label={translate('attachment')}
                            isMandatory={false}
                            multiple
                        />
                    </Layout.Item>
                </>
            )}
        </>
    );
};
